import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {PageHeaderComponent} from '../../common';
import {AgrisBarraBusquedaComponent} from '../common';
import {ConnectionPositionPair} from '@angular/cdk/overlay';
import {AgrisService, PermisosService} from '../../../services';
import {InsumosViewModel, InsumoViewModel, OficinaComercialViewModel, SucursalComercialViewModel} from '../common/AgrisViewModels';
import {MdSnackBar} from '@angular/material';
import {Subscription} from 'rxjs/Subscription';

@Component({
  selector: 'app-agris-buscador',
  templateUrl: './agris-buscador-page.component.html',
  styleUrls: ['./agris-buscador-page.component.scss', '../common/agris-common-styles.scss']
})
export class AgrisBuscadorPageComponent implements AfterViewInit {

  @ViewChild(PageHeaderComponent) header: PageHeaderComponent;
  @ViewChild(AgrisBarraBusquedaComponent) barraBusqueda: AgrisBarraBusquedaComponent;

  resultados: InsumoViewModel[] = [];
  resultadosUnsorted: InsumoViewModel [] = [];
  loading = false;

  typeToggle = true;

  overlayIsOpen = false;

  orderItems = ['Defecto', 'Precio'];
  order = 'Defecto';

  sub: Subscription[] = [];
  sucursal: SucursalComercialViewModel = null;
  oficina: OficinaComercialViewModel = null;
  currentSearch = '';
  retrySearch = false;

  constructor(
    private route: ActivatedRoute,
    public agrisService: AgrisService,
    private permServ: PermisosService,
    private snackBar: MdSnackBar
  ) {
    permServ.verificarAccesoDeURL();
  }

  ngAfterViewInit() {
    this.route.params.subscribe(params => {
      const search = this.route.snapshot.params['search'];
      if (search && search.length) {
        this.barraBusqueda.searchTerm = search.toString().replace('-', ' ');
        this.currentSearch = search.toString().replace('-', ' ');
        this.search();
      } else {
        this.header.navigateBack();
      }

      this.sub.push(
        this.agrisService.oficinaSucursal$.subscribe(x => {
          if (x !== null) {
            this.oficina = x.oficina;
            this.sucursal = x.sucursal;
            this.search();
          }
        })
      )

    });
  }

  toggleFavorito(item, e): void {
    e.stopPropagation();
    item.favourite = !item.favourite;
  }

  search() {
    this.resultados = [];
    this.loading = true;

    if (this.oficina === null || this.sucursal === null) {
      this.agrisService.initializeOficinaSucursal();
      return;
    }
    const payload: InsumosViewModel = {
      IdOficina: this.oficina.Id,
      IdSucursal: this.sucursal.Id,
      filter: this.currentSearch.replace('-', ' '),
      filterFamilia: this.agrisService.filterInsumo.familia !== null ? this.agrisService.filterInsumo.familia.Clave.trim() : '',
      filterLinea: this.agrisService.filterInsumo.linea !== null ? this.agrisService.filterInsumo.linea.Clave.trim() : '',
      filterRubro: this.agrisService.filterInsumo.rubro !== null ? this.agrisService.filterInsumo.rubro.Clave.trim() : '',
      filterSubRubro: this.agrisService.filterInsumo.subRubro !== null ? this.agrisService.filterInsumo.subRubro.Clave.trim() : '',
      listaInsumos: []
    }
    this.sub.push(
      this.agrisService.searchInsumos(payload).subscribe(x => {
        if (x && x.listaInsumos && x.listaInsumos.length) {
          this.resultadosUnsorted = x.listaInsumos as InsumoViewModel[];
          // el endpoint de busqueda no esta paginado por lo que podemos realizar el ordenamiento desde el front
          this.sort();
        }
        this.loading = false;
      }, err => {
        this.loading = false;
        this.agrisService.showSnackbarAPIError();
      })
    );
    // registramos una entrada al history para que el backbutton desde detalle de insumo vuelva a la última busqueda
    history.pushState(null, null, '/agris-buscar/' + this.currentSearch.replace(' ', '-'));
  }

  selectOrder(item) {
    if (this.order === item) { return; }
    this.order = item;
    this.overlayIsOpen = false;
    if (this.resultados.length) {
      this.sort();
    } else {
      this.search();
    }
  }

  sort() {
    // Creamos una copia de los resultados sin ordenar
    this.resultados = [...this.resultadosUnsorted] 

    // Ordenamos según el criterio correspondiente
    switch (this.order) {
      case 'Defecto':
        this.resultados.sort((a, b) => {
          return (a.ProductoBandera - b.ProductoBandera) * -1; // POR DEFECTO: Ordenamiento descendente por Bandera
        });
        break;
      case 'Precio':
        this.resultados.sort((a, b) => {
          return a.PrecioPublico - b.PrecioPublico; // PRECIO: Ascendente
        })
        break;
      default:
        // Sin ordenamiento
        break;
    }
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/agris/agris-buscador-page/agris-buscador-page.component.ts